import i18n from '@/i18n'
import { makeStep } from '../../utils'
import { requireAssetWithFallback } from '@/utils'

const rodColor = (curtainTemplate, curtainType) => {
  //get from api available rod colors
  //at this moment is not available
  // const availableColors = curtainTemplate.available_colors
  const availableColors = ['silver', 'black']

  const priceInfo = curtainTemplate.available_rail_types[0]
  const priceData = () => {
    if (priceInfo) {
      if (!!priceInfo.discount) {
        const original_price = priceInfo.discount.origin_price
        const discount = priceInfo.discount.discount_price
        return `<p class="text-right mb-0">
              ${i18n.t('components.fabricPicker.cardSubTitleWithPrice')}
              <br />
              <strong style="text-decoration: line-through; text-decoration-color:red;" class="text-h3 font-weight-bold primary--text">
                $${original_price}
              </strong>
              <br/>
              <strong class="text-h3 font-weight-bold" style="color: red"> $${discount}
              </strong>
            </p>`
      } else {
        return `<p class="text-right mb-0">
              ${i18n.t('components.fabricPicker.cardSubTitleWithPrice')}
              <br />
              <strong class="text-h3 font-weight-bold primary--text">
                $${priceInfo.price}
              </strong>
            </p>`
      }
    } else {
      return `<p class="text-right mb-0">
            ${i18n.t('components.fabricPicker.cardSubTitlePriceMissing')}
            </p>`
    }
  }
  if (
    curtainType !== 'ringcurtain' ||
    !availableColors ||
    !availableColors.length
  ) {
    return null
  }
  return {
    id: 'color',
    name: i18n.t('components.stepper.rodColor.title'),
    type: 'card',
    choices: availableColors.map((availableColor) => ({
      //todo   infoDialogText:"Lorem ipsum",  ifnoDialogTitle:' Some kind of title"
      title: i18n.t(`enums.RodColor.${availableColor}`),
      value: availableColor,
      imgSrc: requireAssetWithFallback(
        `images/rod_color/${availableColor}.jpeg`
      ),
      subTitle: priceData(),
      infoDialogTitle: i18n.t(`enums.RodColor.informTitle`),
      infoDialogText: i18n.t(`enums.RodColor.informText`),
      infoDialogImage: requireAssetWithFallback(
        `images/rod_color/${availableColor}.jpeg`
      ),
    })),
  }
}

export default (curtainTemplate, curtainType) => {
  const stepQuestions = [rodColor(curtainTemplate, curtainType)]
  return makeStep(stepQuestions, i18n.t('components.stepper.rodColor.title'))
}
